module.exports = __webpack_public_path__ + "media/images/Logo_Tavour_White/Logo_Tavour_White@3x-d35da0b4da7286f824bfb52fa0010d1e.png";